import React, {Component} from 'react';
import MonthCalendar from 'rc-month-calendar';
import "rc-month-calendar/dist/calendar.css";

import ApiService from './ApiService';

let monthsMap = [`Jan`, `Feb`, `Mar`, `Apr`, `May`, `Jun`, `Jul`, `Aug`, `Sep`, `Oct`, `Nov`, `Dec`];

/**
 * Gets the url date.
 *
 * @param      {<type>}  date    The date
 * @return     {Array}   The url date.
 */
function getUrlDate(date) {
  const norm = num => (`0` + num).slice(-2);
  return [date.getFullYear(), norm(date.getMonth() + 1), norm(date.getDate())].join(`/`);
}

/**
 * Gets the enabled dates.
 *
 * @param      {<type>}  temple  The temple
 * @param      {<type>}  days    The days
 * @return     {<type>}  The enabled dates.
 */
function getEnabledDates(temple, days) {

  days = days || temple.lastUpdated.days;

  let enabledDates = days.map(day => {
    let [year, month] = [temple.lastUpdated.years[0], temple.lastUpdated.months[0]];
    return new Date(year, month - 1, day, 12);
  });

  return enabledDates;

}

/**
 * Gets the information from temple.
 *
 * @param      {<type>}  temple  The temple
 * @return     {Object}  The information from temple.
 */
function getInfoFromTemple(temple) {

  // date is null for a temple with no images uploaded yet.
  if (!temple.lastUpdated.date) {
    let currentDate = new Date();
    return {
      temple,
      selectedDate: currentDate,
      enabledDates: [],
      currentDate,
      enabledMonths: [],
      images: [],
      loading: false,
    };
  }

  let [day, month, year] = temple.lastUpdated.date.split(`/`);
  let selectedDate = new Date(year, month - 1, day, 12);
  let enabledDates = getEnabledDates(temple);
  let currentDate = new Date(selectedDate);
  let enabledMonths = temple.lastUpdated.months;

  return {
    temple,
    selectedDate,
    enabledDates,
    currentDate,
    enabledMonths,
    images: temple.lastUpdated.images || [],
    loading: false,
  };
}


/**
 * Uploads an image modal.
 *
 * @class      UploadImageModal (name)
 * @param      {<type>}                        props   The properties
 * @return     {(Array|Date|Function|Object)}  { description_of_the_return_value }
 */
const UploadImageModal = props => (
  <div>
    <div className={`modal-backdrop ` + props.modalOpenClass} onClick={props.closeModalAction}></div>
    <div className={`modal add-temple-modal ` + props.modalOpenClass} tabIndex="-1">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={props.closeModalAction} >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Add New Temple Image</h4>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="temple-image-date">Select Date</label>
              <input type="date" className="form-control" id="temple-image-date" />
            </div>
            <div className="form-group">
              <label htmlFor="temple-image-file">Select Image</label>
              <input type="file" multiple className="form-control" id="temple-image-file" placeholder="Temple name" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={props.closeModalAction}>
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={props.addImage}>Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/**
 * Fetches and set state.
 *
 * @param      {<type>}  urlParams        The url parameters
 * @param      {<type>}  temple           The temple
 * @param      {<type>}  setEnabledDates  The set enabled dates
 * @param      {<type>}  that             The that
 */
function fetchAndSetState(urlParams, temple, setEnabledDates, that) {

  let selectedDate = new Date(urlParams.year, urlParams.month - 1, urlParams.day, 12);

  ApiService.loadJSON(__API_URL__ + `/${temple.id}/${getUrlDate(selectedDate)}`)
    .then(templeData => {

      let state = {
        selectedDate,
        images: templeData,
        loading: false,
      };

      if (setEnabledDates) {
        state.currentDate = new Date(selectedDate);
        that.onMonthChange(new Date(selectedDate));
      }

      that.setState(state);
    });
}

/**
 * Class for Temple Page.
 *
 * @class      Temple (name)
 */
class Temple extends Component {

  constructor(props) {

    super(props);

    let urlParams = this.props.match.params;
    let templeId = urlParams.templeId;

    let temple = (this.props.temples || []).find(temple => temple.id === templeId);
    let dateParams = urlParams.year && urlParams.month && urlParams.day;

    // if no temple present (page reload at this route)
    // fetch temple data first
    if (!temple) {

      this.state = {
        images: [],
        enabledDates: [],
        loading: true,
      };

      ApiService.loadJSON(__API_URL__)
        .then(data => data.find(temple => temple.id === templeId))
        .then(temple => {

          if (!temple) {
            temple = {
              id: templeId,
              lastUpdated: {
                months: [],
                days: [],
                years: [],
                date: getUrlDate(new Date()).split(`/`).reverse().join(`/`),
              },
            };
          }
          this.setState({
            temple,
            enabledMonths: temple.lastUpdated.months,
            enabledDates: dateParams ? [] : getEnabledDates(temple),
          });

          return temple;

        }).then(temple => {

          // if date parameters present in url
          // set current date to date in url else set today as current date
          if (dateParams) {
            fetchAndSetState(urlParams, temple, true, this);
          } else {
            this.setState(getInfoFromTemple(temple));
          }
        });

    } else if (dateParams) {

      fetchAndSetState(urlParams, temple, true, this);
    } else {
      this.state = getInfoFromTemple(temple);
    }

  }

  /**
   * called everytime when props change/received used here for change in current
   * selected date each date in calendar view is link which contains date params
   * clicking on link changes url params and props => triggers the function sets
   * current date and images for selected/clicked date
   *
   * @param      {string}  nextProps  The next properties
   */
  componentWillReceiveProps(nextProps) {
    let urlParams = nextProps.match.params;

    let dateParams = urlParams.year && urlParams.month && urlParams.day;

    if (this.state.temple && dateParams) {

      this.setState({
        images: [],
      });

      fetchAndSetState(urlParams, this.state.temple, false, this);

    } else if (this.state.temple) {
      this.setState(getInfoFromTemple(this.state.temple));
    }

  }

  /**
   * function called when month changes
   * fetch dates having images for the month and disable other dates
   * change can occur through :
   * 1. navigation from calendar next/prev buttons
   * 2. change month from drop down
   * 3. change in url (this also changes the selected date)
   * note : this only changes the current view of calendar,
   *         and not the selected date for which images are shown
   *
   * @param {Object} date : new date/month
   */
  onMonthChange(date) {

    let temple = this.state.temple;
    let selMonth = date.getMonth() + 1;

    let fullYear = date.getFullYear();

    // check if images are available for the year else set all dates as disabled
    if (temple.lastUpdated.years.find(year => ~~year === ~~fullYear)) {

      // to change the current view of month calendar
      this.setState({
        currentDate: date,
      });

      // fetch month details for the year
      ApiService.loadJSON(__API_URL__ + `/${temple.id}/${fullYear}`)
        .then(months => {

          let currMonth = months.find(month => ~~month === selMonth);

          this.setState({
            enabledMonths: months,
          });

          // if passed date month is present in the year get enabled dates
          // else set all dates for the month as disabled
          if (currMonth) {

            ApiService.loadJSON(__API_URL__ + `/${temple.id}/${fullYear}/${currMonth}`)
              .then(days => {
                this.setState({
                  currentDate: date,
                  enabledDates: days.map(day => new Date(fullYear, selMonth - 1, day, 0, 0, 0, 0)),
                });
              });
          } else {
            this.setState({
              currentDate: date,
              enabledDates: [],
            });
          }
        });

    } else {

      this.setState({
        enabledDates: [],
      });
    }

  }


  /**
   * function to call when year changes through drop down changes the currend
   * view for month calendar sets list of enabled months for the year (to
   * enable/disable month on month drop down)
   *
   * @param      {object}  event   - javascript event for select input change
   */
  onYearChange(event) {
    let year = event.target.value;
    let currentDate = this.state.currentDate;
    let temple = this.state.temple;

    currentDate.setYear(year);

    ApiService.loadJSON(__API_URL__ + `/${temple.id}/${year}`)
      .then(months => {

        currentDate.setMonth(months[0] - 1);

        this.setState({
          currentDate,
          enabledMonths: months.data,
        });

        this.onMonthChange(currentDate);
      });
  }

  /**
   * on month drop down change changes current month and calls `onMonthChange`
   * function
   *
   * @param      {Object}  event   javascript event object
   */
  onSelectMonthChange(event) {
    let monthIndex = ~~event.target.value;
    let currentDate = this.state.currentDate;

    currentDate.setMonth(monthIndex);

    this.onMonthChange(currentDate);
  }

  /**
   * Go to date, triggers on selecting/clicking date on calendar view
   *
   * @param      {Object}  date    The date
   */
  goToDate(date) {
    let temple = this.state.temple;

    if (this.props.userLoggedIn) {
      this.props.history.push(`/user/temple/${temple.id}/${getUrlDate(date)}`);
    } else {
      this.props.history.push(`/temple/${temple.id}/${getUrlDate(date)}`);
    }
  }

  /**
   * Determines if date enabled.
   *
   * @param      {Object}   date    The date
   * @return     {boolean}  True if date enabled, False otherwise.
   */
  isDateEnabled(date) {

    let enabledDates = this.state.enabledDates;
    if (!enabledDates) return true;

    return enabledDates.find(enabledDate => enabledDate.toDateString() === date.toDateString());
  }

  addImage() {

    const date = document.getElementById(`temple-image-date`).value;
    const files = document.getElementById(`temple-image-file`).files;
    const temple = this.state.temple;

    ApiService.uploadImages(files, temple.id, date)
      .then(() => {
        this.closeUploadImageModal();
        window.location.reload();
      });
  }

  /**
   * Moves imagen up in order
   */
  moveImgUp(img) {
    ApiService.loadJSON(__API_URL__ + img + `/move/up`, `POST`);
  }

  /**
   * Moves imagen down in order
   */
  moveImgDown(img) {
    ApiService.loadJSON(__API_URL__ + img + `/move/down`, `POST`);
  }

  /**
   * Removes an image.
   */
  removeImg(img, index) {
    var result = confirm(`Are you sure you want to remove the image?`);
    if (result) {
      ApiService.loadJSON(__API_URL__ + img, `DELETE`)
        .then(() => {
          let images = this.state.images;
          images.splice(index, 1);
          this.setState({
            images,
          });
        });
    }
  }

  /**
   * Opens an upload image modal box.
   */
  openUploadImageModal() {
    document.getElementById(`temple-image-date`).valueAsDate = new Date();
    this.setState({
      uploadImageModalOpen: true,
    });
  }

  /**
   * Closes an upload image modal box.
   */
  closeUploadImageModal() {
    this.setState({
      uploadImageModalOpen: false,
    });
  }

  
  /**
   * render function
   */
  render() {

    const temple = this.state.temple;
    const userLoggedIn = this.props.userLoggedIn;

    if (!temple) return (<div></div>);

    document.getElementById(`mainCont`).scrollTop = 0;

    const modalOpenClass = this.state.uploadImageModalOpen ? ` in show ` : ` hidden `;
    const width = Math.min(640, (window.innerWidth > 0) ? window.innerWidth : screen.width);

    const selectedDate = this.state.selectedDate;
    const currentDate = this.state.currentDate;
    let images = this.state.images;

    images = images.map((img, index) => (
      <div key={img} className="date-img">
        {
          userLoggedIn && (
            <div className="row user-logged-in">
              <div className="col-xs-1 action-item-cont">
                {index ? <span onClick={this.moveImgUp.bind(this, img)}
                  className="action-item move-img-up fa fa-arrow-circle-up"></span> : null}
                {index < images.length - 1 ? <span onClick={this.moveImgDown.bind(this, img)}
                  className="action-item move-img-down fa fa-arrow-circle-down"></span> : null}
                <span onClick={this.removeImg.bind(this, img, index)}
                  className="action-item remove-img fa fa-trash"></span>
              </div>
              <div className="col-xs-9 date-img-cont">
                <img src={__IMG_URL__ + `/img/${width}x0/smart/dailydarshans` + img} />
              </div>
            </div>
          )
        }

        {
          !userLoggedIn && (
            <div className="date-img-item">
              <img src={__IMG_URL__ + `/img/${width}x0/smart/dailydarshans` + img} />
            </div>
          )
        }
      </div>
    ));

    return (
      <div className="temple-cont">

        <UploadImageModal
          modalOpenClass={modalOpenClass}
          closeModalAction={this.closeUploadImageModal.bind(this)}
          addImage={this.addImage.bind(this)} />

        <div className="date-header text-center">
          {selectedDate && selectedDate.toDateString()}
        </div>

        <div className="month-cal-cont">
          <div className={`row month-year-select-cont` + (images.length ? `` : ` hidden`)}>
            <div className="col-xs-5 year-select-cont col-xs-offset-1">
              <select className="form-control" onChange={this.onYearChange.bind(this)} >
                {
                  temple.lastUpdated.years.map(year => (
                    <option key={year} selected={(currentDate && currentDate.getFullYear()) === year} >{year}</option>
                  ))
                }
              </select>
            </div>
            <div className="col-xs-5 year-select-cont">
              <select className="form-control" onChange={this.onSelectMonthChange.bind(this)}>
                {
                  monthsMap.map((month, index) => (
                    <option key={month}
                      selected={(currentDate && currentDate.getMonth()) === ~~index}
                      value={~~index}
                      disabled={this.state.enabledMonths.map(m => ~~m).indexOf(index + 1) < 0}>{month}</option>
                  ))
                }
              </select>
            </div>
          </div>

          {this.state.enabledDates &&
            selectedDate &&
            <MonthCalendar
              prevButtonHtml="<span class='fa fa-caret-left'></span>"
              nextButtonHtml="<span class='fa fa-caret-right'></span>"
              isDateEnabled={this.isDateEnabled.bind(this)}
              selectedDate={selectedDate}
              currentDate={currentDate}
              onMonthChange={this.onMonthChange.bind(this)}
              onDateClick={this.goToDate.bind(this)} />
          }
        </div>
        {
          userLoggedIn && (
            <div className="upload-new-image-btn">
              <div className="btn btn-primary btn-block" onClick={this.openUploadImageModal.bind(this)}>
                <span className="fa fa-image"></span> Upload New Image
              </div>
            </div>
          )
        }
        <div className="row img-cont">
          {
            this.state.loading ? (<div className="loader dark smaller"></div>) : images
          }
        </div>

      </div>
    );
  }
}

export default Temple;



// WEBPACK FOOTER //
// ./js/Temple.js